var map = {
	"./bitrix24.png": "3777",
	"./crisp.png": "fbbd",
	"./facebook-chat.png": "2415",
	"./fresh-chat.png": "1c20",
	"./intercom.png": "e3dd",
	"./jivosite.png": "2e97",
	"./octadesk.png": "aff6",
	"./tawkto.png": "40ef",
	"./zendesk.png": "6d2f",
	"./zopim.png": "ae6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7412";